// extracted by mini-css-extract-plugin
export default {"col":"index_col_czrtk","mid_gy":"index_mid_gy_dmDTz","mid_gy_left":"index_mid_gy_left_p-XqY","current":"index_current_cfPF8","mid_gy_right":"index_mid_gy_right_bZY-d"};